var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar',{attrs:{"goUrl":_vm.toUrl}}),_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap"}},[_c('viewer',{staticStyle:{"flex":"1"},attrs:{"images":_vm.imgUrl}},_vm._l((_vm.imgUrl),function(item){return _c('img',{key:item.id,attrs:{"src":item.previewUrl,"width":"125px","height":"120px"}})}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }